import { SvgIcon, useTheme } from '@mui/material';
import React, { ReactElement } from 'react';

export interface FollowIconProps {}

export const FollowIcon = (_props: FollowIconProps): ReactElement => {
  const theme = useTheme();

  return (
    <SvgIcon
      style={{
        width: '20px',
        height: '20px',
        fill: theme.palette.primary.main,
      }}
      viewBox="0 0 20 20"
    >
      <path
        d="M17.8486 0H2.13458C1.56622 0 1.02114 0.22578 0.619247 0.62767C0.217357 1.02956 -0.00842285 1.57464 -0.00842285 2.143L-0.00842285 17.857C-0.00842285 18.4254 0.217357 18.9704 0.619247 19.3723C1.02114 19.7742 1.56622 20 2.13458 20H17.8486C18.4169 20 18.962 19.7742 19.3639 19.3723C19.7658 18.9704 19.9916 18.4254 19.9916 17.857V2.143C19.9916 1.57464 19.7658 1.02956 19.3639 0.62767C18.962 0.22578 18.4169 0 17.8486 0ZM16.4206 11.25C16.4203 11.3921 16.3638 11.5283 16.2633 11.6287C16.1628 11.7292 16.0267 11.7857 15.8846 11.786H11.7776V15.893C11.7773 16.0351 11.7208 16.1713 11.6203 16.2717C11.5198 16.3722 11.3837 16.4287 11.2416 16.429H8.74158C8.5995 16.4287 8.46332 16.3722 8.36286 16.2717C8.2624 16.1713 8.20584 16.0351 8.20558 15.893V11.786H4.09858C3.9565 11.7857 3.82032 11.7292 3.71986 11.6287C3.6194 11.5283 3.56284 11.3921 3.56258 11.25V8.75C3.56284 8.60793 3.6194 8.47174 3.71986 8.37128C3.82032 8.27082 3.9565 8.21426 4.09858 8.214H8.20558V4.107C8.20584 3.96493 8.2624 3.82875 8.36286 3.72828C8.46332 3.62782 8.5995 3.57126 8.74158 3.571H11.2416C11.3837 3.57126 11.5198 3.62782 11.6203 3.72828C11.7208 3.82875 11.7773 3.96493 11.7776 4.107V8.214H15.8846C16.0267 8.21426 16.1628 8.27082 16.2633 8.37128C16.3638 8.47174 16.4203 8.60793 16.4206 8.75V11.25Z"
        fill={theme.palette.primary.main}
      />
    </SvgIcon>
  );
};
